export default "__VITE_ASSET__CM5bMYu4__"